export function describeError(error: Error & { digest?: string }): string {
  const name = (error?.name ?? "").toLowerCase();
  const msg = (error?.message ?? "").toLowerCase();
  const haystack = `${name} ${msg}`;

  if (
    haystack.includes("fetch") ||
    haystack.includes("network") ||
    haystack.includes("offline") ||
    haystack.includes("err_network")
  ) {
    return "네트워크 연결이 불안정해 요청을 마치지 못했어요.";
  }
  if (
    haystack.includes("timeout") ||
    haystack.includes("aborted") ||
    haystack.includes("timed out")
  ) {
    return "요청이 오래 걸려 중단되었어요.";
  }
  if (
    haystack.includes("unauthorized") ||
    haystack.includes("forbidden") ||
    haystack.includes("permission") ||
    haystack.includes("401") ||
    haystack.includes("403")
  ) {
    return "권한 문제로 페이지를 불러오지 못했어요. 로그인 상태를 확인해 주세요.";
  }
  if (haystack.includes("not found") || haystack.includes("404")) {
    return "요청하신 자료를 찾지 못했어요.";
  }
  if (haystack.includes("rate") && haystack.includes("limit")) {
    return "요청이 많아 잠시 제한되었어요. 조금 후 다시 시도해 주세요.";
  }
  if (
    haystack.includes("chunkloaderror") ||
    haystack.includes("loading chunk") ||
    haystack.includes("failed to fetch dynamically imported")
  ) {
    return "새 버전이 배포된 것 같아요. 페이지를 새로고침해 주세요.";
  }
  if (name.includes("syntaxerror") || name.includes("typeerror")) {
    return "페이지를 처리하는 중 오류가 발생했어요.";
  }
  return "예기치 않은 오류가 발생했어요.";
}
